import React from 'react';

/*
  Five stars filled to a product's real average rating.

  Colours are inline rather than class-based so the component can drop into any
  card without each listing having to ship matching CSS.
*/

const ON = '#f59e0b';

const OFF = '#d8d3cb';

function StarRating({
  average = 0,
  count = 0,
  showLabel = true,
  size = '0.8rem',
  className = ''
}) {
  const filled = Math.round(average);

  return (
    <span
      className={`d-inline-flex align-items-center ${className}`}
      style={{ fontSize: size, lineHeight: 1 }}
      title={
        count > 0
          ? `${average.toFixed(1)} out of 5 from ${count} review${
              count === 1 ? '' : 's'
            }`
          : 'No reviews yet'
      }
    >
      <span style={{ letterSpacing: '1px', whiteSpace: 'nowrap' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star} style={{ color: star <= filled ? ON : OFF }}>
            ★
          </span>
        ))}
      </span>

      {showLabel && (
        <small className="text-muted ms-1">
          {count > 0 ? `${average.toFixed(1)} (${count})` : 'No reviews yet'}
        </small>
      )}
    </span>
  );
}

export default StarRating;
